module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEWSURBVEhL7ZIxSgNBFIbXQiIIYi6QwHZivUcQW4+QLncwB4jYBNzKiyhZbSysLDxCihxhQUiRHb83/mEDazPraxQ/+JmZ9+b9b2Z3sn+MpmkG6A59hBBuFPYB0xP0gnHEmiiVBoULNEPX6A1dKn6MpugV1WgeC1Kh8F6HjLAuleoHBgW6RQ9aX8j4neEKHcWNKVB8LtOVme1gfcZwyPjIeKrtaVA4wWBrhoY1Qdas0Bbbc6BpOhitZVzum7qB6cYawFAhX2jwrAa9sUOiJ6Yj2bZYkGS1d5PeWBPZ+oJ3rga1Qi0Ex9bZ6QZL2bYQ9PoHFdPuPyBRf20LuUK+ON7gr74iS3hBg+4rUu5H2OdF37+iX0qWfQJZumC9V7L2QgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-water-hose/light/24.png
// module id = 2552
// module chunks = 2